/**
 * Runtime configuration.
 *
 * The frontend is built once and deployed to five domains, so the CMS address cannot be
 * baked into the bundle. It is read from /config.js at runtime (mounted by Docker Compose
 * or a Kubernetes ConfigMap), with Vite env vars as the development fallback.
 *
 * **An empty `cmsUrl` means "this origin", and that is what production sets.** The CMS is
 * not on the internet: it answers on an internal name reachable over the VPN, and a
 * visitor's browser cannot reach it and should not try. The site's own nginx forwards
 * `/api/website/` and `/uploads/` to it from inside the cluster - see nginx.conf.template,
 * which is the allowlist that makes that safe.
 *
 * Resolving empty to `location.origin` rather than leaving it blank matters twice: `new
 * URL()` needs an absolute base, and `og:image` has to be an absolute URL or the social
 * scrapers that read it will not follow it.
 */
declare global {
  interface Window {
    __WECO_CONFIG__?: { cmsUrl?: string; recaptchaSiteKey?: string; forceRegion?: string };
  }
}

const runtime = typeof window !== 'undefined' ? window.__WECO_CONFIG__ ?? {} : {};

const sameOrigin = typeof window !== 'undefined' ? window.location.origin : '';

export const config = {
  cmsUrl: (runtime.cmsUrl || import.meta.env.VITE_CMS_URL || sameOrigin || 'http://localhost:1337')
    .replace(/\/$/, ''),
  recaptchaSiteKey: runtime.recaptchaSiteKey || import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',
  forceRegion: runtime.forceRegion || import.meta.env.VITE_FORCE_REGION || ''
};

/** Turn a Strapi media URL into an absolute one. */
export function mediaUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  return /^https?:\/\//.test(url) ? url : `${config.cmsUrl}${url}`;
}
